import i18n from 'i18next'
import { useEffect } from 'react'

const applyFontLanguage = (lang: string) => {
  const body = document.body
  const shortLang = lang.split('-')[0]

  if (shortLang === 'km') {
    body.classList.add('khmer-text')
    body.setAttribute('lang', 'km')
  } else {
    body.classList.remove('khmer-text')
    body.setAttribute('lang', 'en')
  }
}

/**
 * Utility to manage font switching between English (Inter) and Khmer (KohSantepheap)
 */
export const useFontLanguage = () => {
  useEffect(() => {
    applyFontLanguage(i18n.language)

    const onLanguageChanged = (lang: string) => {
      applyFontLanguage(lang)
    }

    i18n.on('languageChanged', onLanguageChanged)
    return () => {
      i18n.off('languageChanged', onLanguageChanged)
    }
  }, [])
}

/**
 * Toggle between English and Khmer fonts manually
 * @param lang - 'en' for English, 'km' for Khmer
 */
export const setFontLanguage = (lang: 'en' | 'km') => {
  const body = document.body

  if (lang === 'en') {
    body.classList.remove('khmer-text')
    body.setAttribute('lang', 'en')
  } else if (lang === 'km') {
    body.classList.add('khmer-text')
    body.setAttribute('lang', 'km')
  }
}
